import { GridValidRowModel } from '@mui/x-data-grid-pro';

import { CheckIcon } from '@/components/icons/CheckIcon';
import { PopperContent } from '@/components/poppers/PopperContent';
import { IconRenderer } from '@/components/tables/DataTable/renderers/cell/IconRenderer';
import { ContextualHelpHeaderRenderer } from '@/components/tables/DataTable/renderers/header/ContextualHelpHeaderRenderer';
import { Column } from '@/components/tables/DataTable/types';

export function createPinnedPresentationTemplateColumn<
  RowData extends GridValidRowModel & { isPinned: boolean },
>(): Column<RowData> {
  return {
    field: 'isPinned',
    headerName: 'Pinned',
    width: 120,
    type: 'boolean',
    renderHeader: ContextualHelpHeaderRenderer({
      contextualHelp: (
        <PopperContent body="Pinned templates display as a presentation template option during client onboarding" />
      ),
    }),
    renderCell: IconRenderer<RowData>({
      icon: CheckIcon,
      iconProps: ({ row }) => ({
        sx: {
          visibility: row.isPinned ? 'visible' : 'hidden',
        },
      }),
    }),
  };
}
